/**
 * Pure utility functions for formatting WhatsApp messages
 */

/**
 * Formats a message for WhatsApp display with HTML formatting
 */
export function formatWhatsAppMessage(text: string): string {
    if (!text) return ''

    // Escape HTML first to prevent XSS
    let formatted = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')

    // Format bold text: *text* to <strong>text</strong>
    formatted = formatted.replace(/\*([^*]+)\*/g, '<strong>$1</strong>')

    // Format italic text: _text_ to <em>text</em>
    formatted = formatted.replace(/_([^_]+)_/g, '<em>$1</em>')

    // Format strikethrough: ~text~ to <del>text</del>
    formatted = formatted.replace(/~([^~]+)~/g, '<del>$1</del>')

    // Format monospace: ```text``` to <code>text</code>
    formatted = formatted.replace(/```([^`]+)```/g, '<code>$1</code>')

    // Format URLs: Convert URLs to clickable links
    const urlRegex = /(https?:\/\/[^\s]+)/g
    formatted = formatted.replace(urlRegex, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>')

    // Preserve line breaks
    formatted = formatted.replace(/\n/g, '<br>')

    return formatted
}

/**
 * Extracts URL from message text
 */
export function getMessageUrl(text: string): string | null {
    if (!text) return null
    const urlRegex = /(https?:\/\/[^\s]+)/g
    const match = text.match(urlRegex)
    return match && match.length > 0 ? match[0] : null
}

